import { createSelector, createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
  name: 'messages',
  initialState: {
    notifications: [],
    alertmessage: [],
  },
  reducers: {
    addNotifications(state, action) {
      console.log('HRLLROR', action.payload);
      state.notifications = [...action.payload];
    },
    updateNotifications(state, action) {
      state.notifications = [...state.notifications, ...action.payload];
    },
    pushNotification(state, action) {
      if (action?.payload) {
        state.alertmessage = [...state.alertmessage, ...action.payload];
      }
    },
    popNotification(state) {
      if (state.alertmessage.length) {
        state.alertmessage.shift();
      }
    },
  },
});

export const { updateNotifications, pushNotification, popNotification, addNotifications } =
  notificationSlice.actions;
export const notificationReducer = notificationSlice.reducer;

const selectNotifications = (state) => state.notification;

export const notificationSelector = createSelector(
  [selectNotifications],
  (state) => state.notifications,
);

export const alertNotificationSelector = createSelector(
  [selectNotifications],
  (state) => state.alertmessage,
);
